import { hexToRgba } from '@/theme/color';
import { STAGE_THEME_COLORS } from '@/theme/stage-colors';
import { getConfiguredUiStageId } from '@/utils/stage/stage-utils';

/** Shared top gradient style reused from other game frontends in this repo. */
export function MazePlayTopGradient() {
  const stage = getConfiguredUiStageId();
  const accent = STAGE_THEME_COLORS[stage].resultAccent;
  const top = hexToRgba(accent, 0.95);
  const mid = hexToRgba(accent, 0.32);
  const low = hexToRgba(accent, 0.18);
  const shadowGlow = hexToRgba(accent, 0.72);

  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-x-0 left-0 right-0 top-[-5vh] z-0 mx-auto h-[10vh] max-w-full border-0 blur-[38px]"
      style={{
        background: `linear-gradient(180deg, ${top} 0%, ${mid} 55%, ${low} 82%, transparent 100%)`,
        boxShadow: `0 0 108px ${shadowGlow}`,
      }}
    />
  );
}
